import React, { useEffect, useState } from "react";
import s from "./../../ArchivosSalvta/UploadModal/UploadModal.module.css";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import masiveDistributionServices from "../../../../../api/delivery/masiveDistribution";
import Swal from "sweetalert2";

import { Grid, Modal, Button, CircularProgress } from "@mui/material";
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import InputLabel from "@mui/material/InputLabel"
import FormControl from "@mui/material/FormControl"
import CloseIcon from "@mui/icons-material/Close";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import gamesService from "../../../../../api/games/GamesService";
import { useDispatch } from "react-redux";
import useTranslationException from "../../../../../helpers/exceptions";
import { useNotificationContext } from "../../../../Notifications/CustomNotifications";
import providersService from "src/api/providers/providersService";
import { setProviders } from "src/store/slices/gammaSlice";
const isValidMimeType = (format) => {
  return (format || "").startsWith("text/plain");
};

const CURRENT_GAME_NAME = "Telekino";

const UploadModal = ({ open, setOpen, setEdit, callFiles, cuit }) => {
  const notification = useNotificationContext();
  const { t, i18n } = useTranslation();
  const currentUser = useSelector((state) => state.gamma.logged_user);
  const showExpetion = useTranslationException(t, i18n);
  const [file, setFile] = useState(null);
  const [data, setData] = useState({
    file: "",
    raffleId: 0,
  });
  const [loading, setLoading] = useState(false);
  const [telekino, setTelekino] = useState({});
  const dispatch = useDispatch();
  const [supplierId, setSupplierId] = useState(null);
  const [supplierItems, setSupplierItems] = useState(null);

  useEffect(() => {
    gamesService
      .searchGame(CURRENT_GAME_NAME, dispatch)
      .then((res) => setTelekino(res.content))
      .catch((error) => {
        notification.error("Error ep", error.message);
      });
  }, []);

  const validateBack = async (e) => {
    // Por ahora nada
    return true;
  };

  const validateFront = async (e) => {
    let name = e[0]?.name;
    let regex = /^B\d{10}\.TXT$/;

    // Validación #0: no hacer nada en caso de vacío (cancelar)
    if (!name) {
      return false;
    }
    // Validación #1: formato del nombre
    if (!regex.test((name || "").toUpperCase())) {
      const formato = "BXXXXXXXXXX.txt";
      Swal.fire(t("wrongFile"), `${t("fileFormat")} ${formato}`, "warning");
      return false;
    }
    // Validacion #2: tipo de archivo
    if (!isValidMimeType(e[0]?.type)) {
      Swal.fire(t("wrongFile"), t("fileUploadFormatError"), "warning");
      return false;
    }
    return true;
  };

  const handleSubmitFile = (e) => {
    setLoading(true);
    validateFront(e)
      .then((res) => {
        return res && validateBack(e);
      })
      .then((res) => {
        if (res) {
          let substring = e[0].name.split(".")[0];
          let raffle = substring.substring(substring.length - 4);

          setFile(e[0]);
          setData({
            file: e[0].name,
            raffleId: raffle,
          });
        }
        setLoading(false);
      });
  };

  const processFile = () => {
    setLoading(true);
    const f = new FormData();
    const currentGame = telekino.find((game) => game.name === CURRENT_GAME_NAME)
    let substring = file.name.split(".")[0];
    let raffleNumber = substring.substring(substring.length - 4);
    f.append("file", file, file.name);
    f.append("raffleId", raffleNumber.toString());
    f.append("organizationId", currentUser?.memberships[0]?.organization?.id);
    f.append(
      "organizationName",
      currentUser?.memberships[0]?.organization?.name,
    );
    f.append("cuit", cuit);
    f.append("supplierId", supplierId);

    masiveDistributionServices
      .postTxtFile(f)
      .then((res) => {
        setOpen(false);
        setFile(null);
        setEdit({
          status: true,
          archive: { id: res.fileId },
        });
        setLoading(false);
      })
      .then(() => callFiles())
      .catch((error) => {
        showExpetion.showErrorModalForServiceException(
          error,
          { icon: "warning" },
          t("tryInAMoment"),
        );
        setFile(null);
        setLoading(false);
        setOpen(false);
      });
  };

  useEffect(() => {
    providersService.getProviders(1, 100)
      .then((data) => setSupplierItems(supplierOptions(data.content)))
      .catch((error) => console.log(error))
  }, [])

  console.log(supplierId)
  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("ProcessFiles")}</p>
              <span>{t("uploadFile")}</span>
            </div>
            <CloseIcon
              onClick={() => setOpen(false)}
              className={s.exitIcon}
              sx={{ color: "primary.dark" }}
            />
          </Grid>
          <Grid item xs={10} >
            <Box className={s.selectContainer}>
              <FormControl variant="outlined" size="small">
                <InputLabel id="select-label">Proveedores</InputLabel>
                <Select
                  labelId="select-label"
                  value={supplierId}
                  label="Providers"
                  onChange={(e) => setSupplierId(e.target.value)}
                  className={s.selectInput}
                >
                  {supplierItems}
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid container item xs={12} className={s.filters}>
            <label
              htmlFor="inputTelekinoFile"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid
                container
                item
                xs={10}
                className={s.uploadContainer}
                sx={{
                  "&:hover": {
                    backgroundColor: "secondary.light",
                    cursor: "pointer",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size="4rem" />
                ) : data.file === "" ? (
                  <>
                    <UploadFileRoundedIcon
                      sx={{ fontSize: "3.5rem", color: "primary.dark" }}
                      className={s.uploadIcon}
                    />
                    <p className={s.textUpload}>{t("uploadFile")}</p>
                  </>
                ) : (
                  <Grid container item xs={12} className={s.itemsFile}>
                    <p>{`${t("name")}: ${data.file}`}</p>
                    <p>{`${t("drawNumber")}: ${data.raffleId}`}</p>
                    <p>{`${t("game")}: Telekino`}</p>
                  </Grid>
                )}
              </Grid>
            </label>
            <Grid item xs={12} className={s.button}>
              <Button
                size="small"
                variant="contained"
                onClick={processFile}
                disabled={data.file === "" || loading || supplierId === null}
              >
                {t("process")}
              </Button>
            </Grid>
          </Grid>
          <input
            type="file"
            id="inputTelekinoFile"
            style={{ display: "none" }}
            onChange={(e) => handleSubmitFile(e.target.files)}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default UploadModal;

// ============================ | SELECT CONTENT | =============================

function supplierOptions(data) {
  const items = data.map((item) => {
    return (
      <MenuItem value={item.id} > {item.businessName} </MenuItem>
    )
  })

  return items
}
